import { Button, ButtonProps } from '@distribusion/owl-frontend-ui'
import React, { ReactElement } from 'react'

import { useTranslation } from '@lib/i18n'

interface DefaultPayButtonProps extends Partial<ButtonProps> {
  confirm?: boolean
  proceedToPayment?: boolean
}

const DefaultPayButton = ({ confirm, proceedToPayment, ...rest }: DefaultPayButtonProps): ReactElement => {
  const { t } = useTranslation()

  const getLabel = () => {
    if (confirm) return t(`checkout.confirmButton`)
    /* istanbul ignore next */
    if (proceedToPayment) return t(`checkout.proceedToPay`)
    return t(`checkout.payButton`)
  }

  return (
    <Button dataTag="default-pay-button" buttonType="submit" {...rest}>
      {getLabel()}
    </Button>
  )
}

export default DefaultPayButton
